module.exports = __webpack_public_path__ + "static/img/5-4.829c7e17.png";